import { useMemo } from 'react';
import { useGetRBDMMeetingQuery } from './useGetRBDMMeetingQuery';
import { AllParticipantsObject } from '@components/todayMeetingDetails/components/attendedMembers';

export const useGetRBDMParticipants = (
	id: string | undefined
): {
	data: AllParticipantsObject[];
	isLoading: boolean;
	error: Error | null;
	refetch: () => void;
} => {
	const { data: meetingData, isFetching, error } = useGetRBDMMeetingQuery(id);

	// Transform RBDM meeting members to match AllParticipantsObject structure
	const participants = useMemo((): AllParticipantsObject[] => {
		if (!meetingData?.members || !Array.isArray(meetingData.members)) {
			return [];
		}

		return meetingData.members.map((member) => ({
			firstname: '',
			lastname: '',
			id: member.id || 0,
			lead_id: 0,
			name: '',
			phone: '',
			contactsfid: '',
			clubname: member.club_name_c ?? '',
			producthierarchycode_c: '',
			secondarymobileno_c: null,
			linkedusername_c: null,
			linkeduserphone_c: null,
			non_end_category_c: '',
			app_id_c: '',
			enduserdesignation_c: null,
			natureofwork_c: null,
			convert_lead_c: false,
			member_id: member.member_id || 0,
			sfid: '',
			membershipno_c: member.membershipno_c ?? null,
			campaign_sfid: '',
			campaign_app_id_c: member.campaign_app_id_c ?? '',
			type: member.type ?? '',
			user_type_c: '',
			attendance_c: Boolean(member.attendance_c),
			non_invited_c: Boolean(member.non_invited_c),
			recordtypename_c: '',
			contactid: member.contactid ?? null,
			leadid: '',
			is_repeat_attendee_c: false,
			isconverted_within_5_days_c: false,
			pidilite_employ_c: false,
			status: '',
			lead_app_id_c: member.lead_app_id_c ?? '',
		}));
	}, [meetingData?.members]);

	return {
		data: participants,
		isLoading: isFetching,
		error,
		refetch: (): void => {}, // RBDM meeting query doesn't expose refetch, but we can add it if needed
	};
};
